define('responsive-pitch-fx/lib/workers/Scheduler',['require','exports','module'],function(require,exports,module){

	function Scheduler(){
		this.actionQueue=[];
		this.executionQueue=[];
	}

	Scheduler.prototype={
		ticker 	  : 0,
		addAction : function(action,timing,scope){
			var scheduler=this,
				ticker;
			scope=scope||this;
			ticker=this.ticker+=timing;
			this.actionQueue.push(function(){
				return setTimeout(function(){
					action.call(scope)
				},ticker);
			});
		},
		run 	: function(){
			var i=0,
				items=this.actionQueue,
				len=items.length;
			
			for(; i<len; i++){
				this.executionQueue.push(items.shift()());
			}
			this.ticker=0;
		},
		clear 	: function(){
			this.ticker=0;
			this.executionQueue.forEach(clearTimeout);
			this.actionQueue=[];
		}
	}
	return Scheduler;
});
